import useId from '../utils/useId';
import * as React from 'react';
export const kplusSvg = React.forwardRef(function kplusSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  const id_4 = baseId + '_4';
  const id_5 = baseId + '_5';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_kplus__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00AA51',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M23.96 32 6.974 9 4 22.218 11.534 32H23.96Z',
        fill: `url(#bi_kplus__b_${id_1})`,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M4 22.218V9h2.908v13.218H4Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M32.023 26.58 17.483 9.133l-5.42 6.742L23.959 32h8.064v-5.42Z',
        fill: `url(#bi_kplus__c_${id_2})`,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm13.28 9.787-2.67 3.31 1.982 2.512L17.615 9h-2.69c-.64 0-1.244.29-1.646.787Z',
        fill: `url(#bi_kplus__d_${id_3})`,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm27.5 17.5-3.144-3.741v3.833L27.5 17.5Z',
        fill: '#00A14B',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm32.023 22.218-4.362-5.155-2.38 1.454 6.742 8.064v-4.363Z',
        fill: `url(#bi_kplus__e_${id_4})`,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M22.506 17.063V13.76h1.85v3.304h3.305v1.85h-3.305v3.305h-1.85v-3.304h-3.172v-1.85h3.172Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm22 32-8.5-11 1.5-1 10 12h-3Z',
        fill: `url(#bi_kplus__f_${id_5})`,
        fillOpacity: 0.3,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm10.61 13.098-1.984 2.511 4.653 5.816a2.115 2.115 0 0 0 1.651.793h2.685l-7.006-9.12Z',
        fill: '#fff',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_kplus__b_${id_1}`,
          x1: 6.644,
          y1: 15.213,
          x2: 19.201,
          y2: 32,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#008537',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#00A845',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_kplus__c_${id_2}`,
          x1: 15.103,
          y1: 12.172,
          x2: 32.023,
          y2: 32,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#009541',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#00A945',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_kplus__d_${id_3}`,
          x1: 15.764,
          y1: 9,
          x2: 11.667,
          y2: 14.552,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#C9EEDB',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#80A896',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_kplus__e_${id_4}`,
          x1: 25,
          y1: 16,
          x2: 32,
          y2: 24,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#019E43',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#01A644',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_kplus__f_${id_5}`,
          x1: 12,
          y1: 17.5,
          x2: 24,
          y2: 32.5,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#018E3B',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#01A845',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_kplus__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
      ),
    ),
  );
});
kplusSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kplus = {
  category: 'brand',
  colorable: false,
  name: 'kplus',
  svg: kplusSvg,
};
